import React, { useState, useEffect } from "react";
import gameAssets from "@themed-assets";
import { Separator } from "@/src/components/ui/separator";
import SeriesTicketIcon from "@/src/assets/SeriesTicketIcon";
import TicketIcon from "@/src/assets/TicketIcon";
import RupeeIcon from "@/src/assets/RupeeIcon";
import { format } from "date-fns";
import {
  checkToDisplayValueInCr,
  checkToDisplayValueInK,
  checkToDisplayValueInL,
  parseDecimalValuesOfNumber,
} from "@/Common/utils/GameUtils";
import CountdownTimer, { RunningSinceTimer } from "../Common/CountdownTimer";
import { GameTypeTextAbbr } from "@/Common/utils/GameUtils";
import {
  TOURNEY_STATUS_COMPLETED,
  TOURNEY_STATUS_LIVE,
  TOURNEY_ANNOUNCED,
  TOURNEY_REGISTRATION_STARTED,
  TOURNEY_REGISTRATION_ENDED,
  TOURNEY_STATUS_CANCELLED,
  TOURNEY_STATUS_MISSED,
  TICKET_BASED,
  TICKETS,
  TOURNEY_STATUS_WON,
  TOURNEY_TYPES,
} from "@/Poker/data/Constants";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverAnchor,
} from "../ui/popover";
import { usePlayer } from "@/src/hooks/data/useLobby";

const rankAssetConfig = {
  1: gameAssets.PodiumRank1,
  2: gameAssets.PodiumRank2,
  3: gameAssets.PodiumRank3,
};

function TourneyDetailsOverviewCard({
  showRank = false,
  selectedTourneyDetails,
}) {
  const {
    lateRegEnded,
    lateRegEndTime,
    breakEven,
    dynamicPoolPrize,
    tourneyStartTime,
    prizePool,
    prizePoolTickets,
    bountyBuyIn,
    bountyTourney,
    bountyTourneyPrizePool,
    tourneyRake,
    buyIn,
    tournamentType,
    registeredPlayerCount,
    maxPlayers,
    totalReEntryCount,
    displayWinners,
    totalWinners,
    familyName,
    gameType,
    reEntry,
    playersPerTable,
    top3RankList = [],
    tourneyStatus,
    reEntryType,
    inTheMoney,
    tourneyEndTime,
    entryFee,
    noOfRebuys,
    totalAddOnCount,
    activePlayerForTourney,
    qualifiedPlayerCount = 0,
    stackDetails = null,
    tourneyIdentifier,
    startingStack,
    averageChips,
    highestStack,
    lowestStack,
  } = selectedTourneyDetails;

  // const breakEven = selectedTourneyDetails?.breakEven
  const [remainingStartTime, setRemainingStartTime] = useState(-1);
  const currentLobbyTime = new Date();

  const user = usePlayer();

  // useEffect(() => {
  //   if (tourneyStatus === TOURNEY_STATUS_LIVE) {
  //     handleTourneyStatusLiveTimer();
  //   } else {
  //     handleTourneyRemainingTimeToStartTimer();
  //   }
  //   return () => {};
  // }, []);
  useEffect(() => {
    if (tourneyStatus === TOURNEY_STATUS_LIVE) {
      handleTourneyStatusLiveTimer();
    } else {
      handleTourneyRemainingTimeToStartTimer();
    }
    return () => {};
  }, [tourneyStatus]);

  const handleTourneyStatusLiveTimer = () => {
    const difference = currentLobbyTime - new Date(tourneyStartTime * 1000);
    setRemainingStartTime(Math.floor(difference / 1000));
  };

  const handleTourneyRemainingTimeToStartTimer = () => {
    const difference = new Date(tourneyStartTime * 1000) - currentLobbyTime;
    setRemainingStartTime(Math.floor(difference / 1000));
  };

  const getTourneyBuyIn = () => {
    if (bountyTourney) {
      return buyIn + tourneyRake + bountyBuyIn;
    } else {
      return buyIn + tourneyRake;
    }
  };

  const getTimerTextBasedOnTourneyStage = (currentTourneyStatus) => {
    switch (currentTourneyStatus) {
      case TOURNEY_STATUS_LIVE:
        if (remainingStartTime >= 0) {
          if (!lateRegEnded && lateRegEndTime > 0 && !inTheMoney) {
            return "Late Reg ends in ";
          }
          return "Running Since";
        } else {
          return "About to start";
        }
      case TOURNEY_ANNOUNCED:
        return "Reg. Starts in";
      case TOURNEY_REGISTRATION_STARTED:
      case TOURNEY_REGISTRATION_ENDED:
        // if (remainingStartTime >= 0) {
        return "Starting Soon";
      // } else {
      //   return "About to start";
      // }
      case TOURNEY_STATUS_WON:
        return "You Won";
      case TOURNEY_STATUS_COMPLETED:
        return "Tourney Finished";
      case TOURNEY_STATUS_CANCELLED:
        return "Cancelled";
      case TOURNEY_STATUS_MISSED:
        return "Missed";
      default:
        return "";
    }
  };
  const getTimerValueBasedOnTourneyStage = (currentTourneyStatus) => {
    switch (currentTourneyStatus) {
      case TOURNEY_STATUS_LIVE:
        if (remainingStartTime >= 0) {
          if (!lateRegEnded && lateRegEndTime > 0 && !inTheMoney) {
            return (
              <CountdownTimer
                startTime={selectedTourneyDetails?.lateRegEndTime * 1000}
                isHours
                isMinutes
                isSeconds
              />
            );
          }
          // return format(
          //   new Date(selectedTourneyDetails.tourneyStartTime * 1000),
          //   " hh:mm a"
          // );
          return selectedTourneyDetails.tourneyStartTime ? (
            <RunningSinceTimer
              startTimestamp={Number(
                selectedTourneyDetails.tourneyStartTime * 1000
              )}
            />
          ) : (
            "-"
          );
        } else {
          return "00:00";
        }
      case TOURNEY_ANNOUNCED:
        return (
          <CountdownTimer
            startTime={selectedTourneyDetails?.registrationStartTime * 1000}
            isHours
            isMinutes
            isSeconds
          />
        );
      case TOURNEY_REGISTRATION_STARTED:
      case TOURNEY_REGISTRATION_ENDED:
        // if (remainingStartTime >= 0) {
        return (
          <CountdownTimer
            startTime={selectedTourneyDetails?.tourneyStartTime * 1000}
            isHours
            isMinutes
            isSeconds
          />
        );
      // } else {
      //   return "00:00";
      // }
      case TOURNEY_STATUS_WON:
      case TOURNEY_STATUS_COMPLETED:
      case TOURNEY_STATUS_MISSED:
        return selectedTourneyDetails?.tourneyEndTime
          ? format(
              new Date(selectedTourneyDetails?.tourneyEndTime * 1000),
              " dd MMM"
            )
          : "-";
      case TOURNEY_STATUS_CANCELLED:
        // case TOURNEY_STATUS_MISSED:
        return "-";
      default:
        return "";
    }
  };

  const getStatusColorBasedOnTourneyStage = (currentTourneyStatus) => {
    switch (currentTourneyStatus) {
      case TOURNEY_STATUS_LIVE:
        if (remainingStartTime >= 0) {
          if (!lateRegEnded && lateRegEndTime > 0) {
            return "error-primary";
          }
          return "link";
        } else {
          return "secondary";
        }
      case TOURNEY_STATUS_WON:
      case TOURNEY_ANNOUNCED:
      case TOURNEY_REGISTRATION_STARTED:
      case TOURNEY_REGISTRATION_ENDED:
        return "success";
      // if (remainingStartTime >= 0) {
      // } else {
      //   return "success";
      // }
      case TOURNEY_STATUS_COMPLETED:
      case TOURNEY_STATUS_CANCELLED:
      case TOURNEY_STATUS_MISSED:
        return "secondary";
      default:
        return "secondary";
    }
  };

  const getTopThreeRanks = (players) => {
    let rankMap = new Map(); // To store unique ranks

    for (let player of players) {
      if (!rankMap.has(player.rank) && player.rank > 0 && player.rank <= 3) {
        rankMap.set(player.rank, player);
      }
      if (rankMap.size === 3) break; // Stop once we have 3 unique ranks
    }

    // Convert Map values to an array and sort in the order [2, 1, 3]
    const rankOrder = [2, 1, 3];
    return Array.from(rankMap.values()).sort(
      (a, b) => rankOrder.indexOf(a.rank) - rankOrder.indexOf(b.rank)
    );
  };

  const Top3Rank = () => {
    let topRanks = getTopThreeRanks(top3RankList);
    return (
      <div className="flex justify-center items-end -mt-7">
        {topRanks.map((player, index) => (
          <div
            style={{
              flex: player.rank == 1 ? 0.4 : 0.3,
            }}
            className="flex relative justify-center"
          >
            {/* <img src={gameAssets.PodiumRank2} /> */}
            <img src={rankAssetConfig[player.rank]} />
            <div className={`absolute bottom-0 left-0 right-0  flex flex-col`}>
              <div className={`text-lightgray text-xs font-medium text-center`}>
                {player?.playerName || ""}
                {player?.playerName === user?.player?.userName ? "(you)" : ""}
              </div>
              <div
                className={`text-yellow-500 text-xs font-medium text-center`}
              >
                ₹
                {parseDecimalValuesOfNumber(
                  player?.winningAmount + player?.winningBonusAmount,
                  2,
                  checkToDisplayValueInK(
                    player?.winningAmount + player?.winningBonusAmount
                  ),
                  checkToDisplayValueInL(
                    player?.winningAmount + player?.winningBonusAmount
                  ),
                  checkToDisplayValueInCr(
                    player?.winningAmount + player?.winningBonusAmount
                  )
                )}
              </div>
            </div>
          </div>
        ))}
        {/* {topRanks?.[0] && (
          <div
            style={{
              flex: 0.3,
            }}
            className="flex relative "
          >
            <img src={gameAssets.PodiumRank2} />
            <div className={`absolute bottom-0 left-0 right-0  flex flex-col`}>
              <div className={`text-lightgray text-xs font-medium text-center`}>
                {topRanks?.[0]?.playerName || ""}
                {topRanks?.[0]?.playerName === user?.player?.userName
                  ? "(you)"
                  : ""}
              </div>
              <div
                className={`text-yellow-500 text-xs font-medium text-center`}
              >
                ₹
                {parseDecimalValuesOfNumber(
                  topRanks?.[0]?.winningAmount +
                    topRanks?.[0]?.winningBonusAmount,
                  2,
                  checkToDisplayValueInK(
                    topRanks?.[0]?.winningAmount +
                      topRanks?.[0]?.winningBonusAmount
                  ),
                  checkToDisplayValueInL(
                    topRanks?.[0]?.winningAmount +
                      topRanks?.[0]?.winningBonusAmount
                  ),
                  checkToDisplayValueInCr(
                    topRanks?.[0]?.winningAmount +
                      topRanks?.[0]?.winningBonusAmount
                  )
                )}
              </div>
            </div>
          </div>
        )}
        {topRanks?.[1] && (
          <div style={{ flex: 0.4 }} className="flex relative justify-center">
            <img src={gameAssets.PodiumRank1} />
            <div className={`absolute bottom-0 left-0 right-0  flex flex-col`}>
              <div className={`text-lightgray text-xs font-medium text-center`}>
                {topRanks?.[1]?.playerName || ""}
                {topRanks?.[1]?.playerName === user?.player?.userName
                  ? "(you)"
                  : ""}
              </div>
              <div
                className={`text-yellow-500 text-sm font-medium text-center`}
              >
                ₹
                {parseDecimalValuesOfNumber(
                  topRanks?.[1]?.winningAmount +
                    topRanks?.[1]?.winningBonusAmount,
                  2,
                  checkToDisplayValueInK(
                    topRanks?.[1]?.winningAmount +
                      topRanks?.[1]?.winningBonusAmount
                  ),
                  checkToDisplayValueInL(
                    topRanks?.[1]?.winningAmount +
                      topRanks?.[1]?.winningBonusAmount
                  ),
                  checkToDisplayValueInCr(
                    topRanks?.[1]?.winningAmount +
                      topRanks?.[1]?.winningBonusAmount
                  )
                )}
              </div>
            </div>
          </div>
        )}
        {topRanks?.[2] && (
          <div style={{ flex: 0.3 }} className="flex relative ">
            <img src={gameAssets.PodiumRank3} />
            <div className={`absolute bottom-0 left-0 right-0  flex flex-col`}>
              <div className={`text-lightgray text-xs font-medium text-center`}>
                {topRanks?.[2]?.playerName || ""}
                {topRanks?.[2]?.playerName === user?.player?.userName
                  ? "(you)"
                  : ""}
              </div>
              <div
                className={`text-yellow-500 text-xs font-medium text-center`}
              >
                ₹
                {parseDecimalValuesOfNumber(
                  topRanks?.[2]?.winningAmount +
                    topRanks?.[2]?.winningBonusAmount,
                  2,
                  checkToDisplayValueInK(
                    topRanks?.[2]?.winningAmount +
                      topRanks?.[2]?.winningBonusAmount
                  ),
                  checkToDisplayValueInL(
                    topRanks?.[2]?.winningAmount +
                      topRanks?.[2]?.winningBonusAmount
                  ),
                  checkToDisplayValueInCr(
                    topRanks?.[2]?.winningAmount +
                      topRanks?.[2]?.winningBonusAmount
                  )
                )}
              </div>
            </div>
          </div>
        )} */}
      </div>
    );
  };

  const SmallDataCard = ({ title = "", value = "" }) => {
    return (
      <div
        style={{
          flex: 0.33,
        }}
        className={`flex items-center flex-col gap-2`}
      >
        <div className={`text-2xs uppercase text-secondary`}>{title}</div>
        <div className="text-sm font-bold px-1 text-primary">{value}</div>
      </div>
    );
  };

  return (
    <div
      className={`overflow-hidden rounded-300 border border-solid border-b-solid border-b-foreground border-foreground bg-radial from-accent/80 to-foreground`}
    >
      <div>
        {/* section-1 */}
        <div
          className="h-16 relative"
          style={{
            backgroundImage: `url(${gameAssets.TourneyDetailsOverviewCard})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {getTimerTextBasedOnTourneyStage(tourneyStatus) && (
            <div
              // className={`absolute -bottom-4 rounded-lg rounded-b-3xl bg-${getStatusColorBasedOnTourneyStage(tourneyStatus)}/20`}
              className={`absolute -bottom-4 rounded-lg rounded-b-3xl 
                ${
                  getStatusColorBasedOnTourneyStage(tourneyStatus) == "link"
                    ? "bg-link/20"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "secondary"
                    ? "bg-secondary/20"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "error-primary"
                    ? "bg-error-primary/20"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "success"
                    ? "bg-success/20"
                    : ""
                }
                `}
              style={{
                left: "37%",
                width: 90,
              }}
            >
              <div
                // className={`text-2xs text-center text-${getStatusColorBasedOnTourneyStage(tourneyStatus)} py-1`}
                className={`text-2xs text-center ${
                  getStatusColorBasedOnTourneyStage(tourneyStatus) == "link"
                    ? "text-link"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "secondary"
                    ? "text-secondary"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "error-primary"
                    ? "text-error-primary"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "success"
                    ? "text-success"
                    : ""
                } py-1`}
              >
                {/* Starting Soon  */}
                {getTimerTextBasedOnTourneyStage(tourneyStatus)}
              </div>

              <div
                style={
                  {
                    // width: "100%",
                  }
                }
                // className={`text-xs font-medium bg-black p-2 rounded-3xl border border-${getStatusColorBasedOnTourneyStage(tourneyStatus)}/40 text-center`}
                className={`text-xs font-bold bg-black px-2 py-2.5 rounded-3xl border ${
                  getStatusColorBasedOnTourneyStage(tourneyStatus) == "link"
                    ? "border-link/40"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "secondary"
                    ? "border-secondary/40"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "error-primary"
                    ? "border-error-primary/40"
                    : getStatusColorBasedOnTourneyStage(tourneyStatus) ==
                      "success"
                    ? "border-success/40"
                    : ""
                } text-center`}
              >
                {getTimerValueBasedOnTourneyStage(tourneyStatus)}
              </div>
            </div>
          )}
          {/* status capsule end */}
          <div
            className={`flex items-center py-1 px-1 justify-between relative`}
          >
            <div className="flex items-center">
              {familyName?.nameA23 && (
                <div className="bg-header-fg p-1.5 font-bold rounded-200 text-3xs text-focus mx-1 uppercase max-w-18 truncate">
                  {/* Epic */}
                  {familyName?.nameA23 ?? familyName?.nameA23}
                </div>
              )}

              <div className="bg-header-fg p-1.5 font-bold rounded-200 text-3xs text-info mx-1 uppercase max-w-18 truncate">
                {/* Holdem */}
                {GameTypeTextAbbr(gameType)}
              </div>
            </div>
            <div className={`flex items-center`}>
              {(reEntry ||
                reEntryType === "RebuyWithAddOn" ||
                reEntryType === "RebuyWithoutAddOn") && (
                <div className="bg-header-fg p-1.5 font-bold rounded-200 text-3xs text-secondary mx-1 uppercase max-w-18 truncate">
                  {reEntry
                    ? "Re-entry"
                    : reEntryType === "RebuyWithAddOn"
                    ? "Rebuy+A"
                    : "Rebuy"}
                </div>
              )}
              {playersPerTable && (
                <div className="bg-header-fg p-1.5 font-bold rounded-200 text-3xs text-secondary mx-1 uppercase max-w-16 truncate">
                  {playersPerTable}-max
                </div>
              )}
            </div>
          </div>
        </div>

        {/* section-2 */}
        <div className="p-4">
          <div className={`pt-4 pb-2.5`}>
            {tourneyStatus === TOURNEY_STATUS_CANCELLED && tourneyEndTime ? (
              <div className="flex justify-center mb-3">
                <div className="text-2xs text-secondary font-medium bg-header-accent2 px-4 py-1 rounded-full">
                  {`Cancelled on: `}
                  {format(new Date(tourneyEndTime * 1000), "dd MMM, hh:mm a")}
                </div>
              </div>
            ) : tourneyStartTime ? (
              <div className="flex justify-center mb-3">
                <div className="text-2xs text-secondary font-medium bg-header-accent2 px-4 py-1 rounded-full">
                  {tourneyStatus === TOURNEY_STATUS_LIVE
                    ? `Start At: `
                    : `Start time: `}
                  {format(new Date(tourneyStartTime * 1000), "dd MMM, hh:mm a")}
                </div>
              </div>
            ) : (
              <div />
            )}
            {tournamentType !== TOURNEY_TYPES.FLIGHT_CHILD && (
              <div className={`flex justify-center`}>
                <div className={`flex items-center`}>
                  <div
                    className={`uppercase text-xs text-secondary font-normal mr-2.5`}
                  >
                    Prize Pool
                  </div>
                  {bountyTourney ? (
                    <div className={`flex items-center`}>
                      {/* <img className={`w-4 h-4`} src={gameAssets.RupeeIcon} /> */}
                      <RupeeIcon />

                      <div className={`text-base font-bold text-warning ml-1`}>
                        {parseDecimalValuesOfNumber(
                          bountyTourneyPrizePool,
                          2,
                          checkToDisplayValueInK(bountyTourneyPrizePool),
                          checkToDisplayValueInL(bountyTourneyPrizePool),
                          checkToDisplayValueInCr(bountyTourneyPrizePool)
                        )}
                      </div>
                    </div>
                  ) : (
                    ((breakEven && dynamicPoolPrize > 0) || prizePool > 0) && (
                      <div className={`flex items-center`}>
                        {/* <img className={`w-4 h-4`} src={gameAssets.RupeeIcon} /> */}
                        <RupeeIcon />

                        <div
                          className={`text-base font-bold text-warning ml-1`}
                        >
                          {breakEven
                            ? dynamicPoolPrize > 0
                              ? `${parseDecimalValuesOfNumber(
                                  dynamicPoolPrize,
                                  2,
                                  checkToDisplayValueInK(dynamicPoolPrize),
                                  checkToDisplayValueInL(dynamicPoolPrize),
                                  checkToDisplayValueInCr(dynamicPoolPrize)
                                )}`
                              : ""
                            : prizePool > 0
                            ? `${parseDecimalValuesOfNumber(
                                prizePool,
                                2,
                                checkToDisplayValueInK(prizePool),
                                checkToDisplayValueInL(prizePool),
                                checkToDisplayValueInCr(prizePool)
                              )}`
                            : ""}
                        </div>
                      </div>
                    )
                  )}
                  {prizePoolTickets > 0 && (
                    <div className={`flex items-center gap-1s`}>
                      {((breakEven && dynamicPoolPrize > 0) ||
                        prizePool > 0) && (
                        <div
                          className={`text-base font-bold text-warning mx-1.5`}
                        >
                          +
                        </div>
                      )}
                      <TicketIcon count={prizePoolTickets} />
                      <div className={`text-base font-bold text-warning ml-2`}>
                        Ticket{prizePoolTickets > 1 ? "s" : ""}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {tournamentType === TOURNEY_TYPES.FLIGHT_CHILD && (
              <div className="flex items-center justify-center">
                <div className="text-secondary font-regular text-xs text-center">
                  SURVIVORS QUALIFY FOR
                </div>
                <div className="text-warning font-bold text-sm ml-1 text-center">
                  {selectedTourneyDetails?.parentTourneyName || ""}
                </div>
              </div>
            )}

            {/* Podium Section */}
            {top3RankList?.length > 0 &&
              (tourneyStatus == TOURNEY_STATUS_COMPLETED ||
                tourneyIdentifier === "completedTourneys") &&
              tournamentType !== TOURNEY_TYPES.FLIGHT_CHILD && <Top3Rank />}
            {/* Podium Section Ends */}
          </div>

          {/* sub-section 1 */}
          <Separator className={"border-foreground border border-solid"} />
          <Separator className={"border-surface/40 border border-solid"} />
          <div className={`flex justify-evenly pt-4 pb-1`}>
            {/* 1 */}
            <div
              className="flex flex-col items-center gap-2"
              style={{
                flex: 0.33,
              }}
            >
              <div className={`text-2xs uppercase text-secondary`}>BUY-IN</div>
              <div className="flex items-center justify-center">
                <img
                  className="object-cover object-top"
                  height="18px"
                  width="20px"
                  src={gameAssets.CurrencyNoteIcon}
                />
                {/* <NewRupeeIcon /> */}
                <div className="text-sm font-bold px-1 text-primary">
                  {/* ₹{" "} */}
                  {tournamentType === TICKET_BASED
                    ? TICKETS
                    : getTourneyBuyIn() || 0}
                </div>
                <div>
                  <Popover>
                    <PopoverTrigger asChild>
                      <img
                        src={gameAssets.InfoIcon}
                        className="object-cover"
                        height="16px"
                        width="16px"
                      />
                    </PopoverTrigger>
                    <PopoverContent
                      className={
                        "bg-foreground border-surface border w-fit p-2"
                      }
                    >
                      <div className="text-2xs font-medium">
                        ₹{entryFee || 0} Entry Fee
                      </div>
                      {bountyBuyIn > 0 && (
                        <div className="text-2xs font-medium mt-1">
                          ₹{bountyBuyIn || 0} Bounty Fee
                        </div>
                      )}
                      {tourneyRake > 0 && (
                        <div className="text-2xs font-medium mt-1">
                          ₹{tourneyRake || 0} Rake
                        </div>
                      )}
                    </PopoverContent>
                  </Popover>
                </div>
              </div>
            </div>
            {/* 2 */}
            <div
              style={{
                flex: 0.33,
              }}
              className={`flex items-center flex-col gap-2`}
            >
              <div className={`text-2xs uppercase text-secondary`}>Entries</div>
              <div className={`flex items-center justify-center`}>
                <div>
                  <img
                    className="object-cover"
                    height="16px"
                    width="16px"
                    src={gameAssets.userIcon}
                  />
                </div>
                {tourneyStatus === TOURNEY_STATUS_LIVE ? (
                  <div className="text-sm font-bold px-1 text-primary">
                    {/* 510/600 */}
                    {`${
                      parseDecimalValuesOfNumber(
                        activePlayerForTourney,
                        2,
                        checkToDisplayValueInK(activePlayerForTourney),
                        checkToDisplayValueInL(activePlayerForTourney),
                        checkToDisplayValueInCr(activePlayerForTourney)
                      ) || 0
                    }/${
                      parseDecimalValuesOfNumber(
                        registeredPlayerCount,
                        2,
                        checkToDisplayValueInK(registeredPlayerCount),
                        checkToDisplayValueInL(registeredPlayerCount),
                        checkToDisplayValueInCr(registeredPlayerCount)
                      ) || 0
                    }`}
                  </div>
                ) : (
                  <div className="text-sm font-bold px-1 text-primary">
                    {/* 510/600 */}
                    {`${
                      parseDecimalValuesOfNumber(
                        registeredPlayerCount,
                        2,
                        checkToDisplayValueInK(registeredPlayerCount),
                        checkToDisplayValueInL(registeredPlayerCount),
                        checkToDisplayValueInCr(registeredPlayerCount)
                      ) || 0
                    }/${
                      parseDecimalValuesOfNumber(
                        maxPlayers,
                        2,
                        checkToDisplayValueInK(maxPlayers),
                        checkToDisplayValueInL(maxPlayers),
                        checkToDisplayValueInCr(maxPlayers)
                      ) || 0
                    }`}
                  </div>
                )}
                <div>
                  <Popover>
                    <PopoverTrigger asChild>
                      <img
                        src={gameAssets.InfoIcon}
                        className="object-cover"
                        height="16px"
                        width="16px"
                      />
                    </PopoverTrigger>
                    <PopoverContent
                      className={
                        "bg-foreground border-surface border w-fit p-2"
                      }
                    >
                      {reEntry !== null && reEntry !== undefined && (
                        <div className="text-2xs font-medium">
                          {totalReEntryCount || 0} Re-entries
                        </div>
                      )}

                      {noOfRebuys !== null && noOfRebuys !== undefined && (
                        <div className="text-2xs font-medium mt-1">
                          {noOfRebuys || 0} Re-buys
                        </div>
                      )}

                      {totalAddOnCount !== null &&
                        totalAddOnCount !== undefined && (
                          <div className="text-2xs font-medium mt-1">
                            {totalAddOnCount} Addon
                          </div>
                        )}
                    </PopoverContent>
                  </Popover>
                </div>
              </div>
              {totalReEntryCount > 0 &&
                tourneyStatus !== TOURNEY_STATUS_CANCELLED &&
                tourneyStartTime * 1000 < new Date().getTime() && (
                  <div className={`text-2xs text-secondary`}>
                    {totalReEntryCount} Re-entries
                  </div>
                )}
            </div>
            {/* 3 */}
            {/* {tournamentType === TOURNEY_TYPES.FLIGHT_CHILD && tourneyStatus === TOURNEY_STATUS_LIVE ? */}
            {tournamentType === TOURNEY_TYPES.FLIGHT_CHILD ? (
              tourneyStatus === TOURNEY_STATUS_LIVE ? (
                <div />
              ) : tourneyStatus === TOURNEY_STATUS_COMPLETED ||
                tourneyIdentifier === "completedTourneys" ? (
                <div
                  style={{
                    flex: 0.33,
                  }}
                  className={`flex items-center flex-col gap-2`}
                >
                  <div className={`text-2xs uppercase text-secondary`}>
                    Players Qualified
                  </div>
                  <div className="flex items-center justify-center">
                    <div>
                      <img
                        src={gameAssets.PodiumIcon}
                        className="object-cover"
                        height="16px"
                        width="16px"
                      />
                    </div>
                    <div className="text-sm font-bold px-1 text-primary">
                      {parseDecimalValuesOfNumber(
                        qualifiedPlayerCount,
                        2,
                        checkToDisplayValueInK(qualifiedPlayerCount),
                        checkToDisplayValueInL(qualifiedPlayerCount),
                        checkToDisplayValueInCr(qualifiedPlayerCount)
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    flex: 0.33,
                  }}
                  className={`flex items-center flex-col gap-2`}
                >
                  <div className={`text-2xs uppercase text-secondary`}>
                    Paid Positions
                  </div>
                  <div className="flex items-center justify-center">
                    <div>
                      <img
                        src={gameAssets.PodiumIcon}
                        className="object-cover"
                        height="16px"
                        width="16px"
                      />
                    </div>
                    <div className="text-sm font-bold px-1 text-primary">
                      {parseDecimalValuesOfNumber(
                        displayWinners,
                        2,
                        checkToDisplayValueInK(displayWinners),
                        checkToDisplayValueInL(displayWinners),
                        checkToDisplayValueInCr(displayWinners)
                      )}
                    </div>
                  </div>
                </div>
              )
            ) : (
              <div
                style={{
                  flex: 0.33,
                }}
                className={`flex items-center flex-col gap-2`}
              >
                <div className={`text-2xs uppercase text-secondary`}>
                  Paid Positions
                </div>
                <div className="flex items-center justify-center">
                  <div>
                    <img
                      src={gameAssets.PodiumIcon}
                      className="object-cover"
                      height="16px"
                      width="16px"
                    />
                  </div>
                  <div className="text-sm font-bold px-1 text-primary">
                    {parseDecimalValuesOfNumber(
                      totalWinners,
                      2,
                      checkToDisplayValueInK(totalWinners),
                      checkToDisplayValueInL(totalWinners),
                      checkToDisplayValueInCr(totalWinners)
                    )}
                    {/* {parseDecimalValuesOfNumber(
                      displayWinners,
                      2,
                      checkToDisplayValueInK(displayWinners),
                      checkToDisplayValueInL(displayWinners),
                      checkToDisplayValueInCr(displayWinners)
                    )} */}
                  </div>
                </div>
              </div>
            )}
          </div>
          {tournamentType === TOURNEY_TYPES.FLIGHT_CHILD &&
            (tourneyStatus === TOURNEY_STATUS_COMPLETED ||
              tourneyIdentifier === "completedTourneys") && (
              <div>
                <div className={`flex justify-evenly pt-4 pb-1`}>
                  <SmallDataCard
                    title={"Smallest Stack"}
                    value={
                      parseDecimalValuesOfNumber(
                        lowestStack,
                        2,
                        checkToDisplayValueInK(lowestStack),
                        checkToDisplayValueInL(lowestStack),
                        checkToDisplayValueInCr(lowestStack)
                      ) || 0
                    }
                    // value={
                    //   parseDecimalValuesOfNumber(
                    //     stackDetails?.minStack,
                    //     2,
                    //     checkToDisplayValueInK(stackDetails?.minStack),
                    //     checkToDisplayValueInL(stackDetails?.minStack),
                    //     checkToDisplayValueInCr(stackDetails?.minStack)
                    //   ) || 0
                    // }
                  />
                  <SmallDataCard
                    title={"Average Stack"}
                    value={
                      parseDecimalValuesOfNumber(
                        averageChips,
                        2,
                        checkToDisplayValueInK(averageChips),
                        checkToDisplayValueInL(averageChips),
                        checkToDisplayValueInCr(averageChips)
                      ) || 0
                    }
                    // value={
                    //   parseDecimalValuesOfNumber(
                    //     stackDetails?.averageStack,
                    //     2,
                    //     checkToDisplayValueInK(stackDetails?.averageStack),
                    //     checkToDisplayValueInL(stackDetails?.averageStack),
                    //     checkToDisplayValueInCr(stackDetails?.averageStack)
                    //   ) || 0
                    // }
                  />
                  <SmallDataCard
                    title={"largest Stack"}
                    value={
                      parseDecimalValuesOfNumber(
                        highestStack,
                        2,
                        checkToDisplayValueInK(highestStack),
                        checkToDisplayValueInL(highestStack),
                        checkToDisplayValueInCr(highestStack)
                      ) || 0
                    }
                    // value={
                    //   parseDecimalValuesOfNumber(
                    //     stackDetails?.maxStack,
                    //     2,
                    //     checkToDisplayValueInK(stackDetails?.maxStack),
                    //     checkToDisplayValueInL(stackDetails?.maxStack),
                    //     checkToDisplayValueInCr(stackDetails?.maxStack)
                    //   ) || 0
                    // }
                  />
                </div>
                {stackDetails?.qualified && (
                  <div
                    className={`flex py-1 mt-3 items-center justify-center bg-linear-to-r from-foreground via-accent to-foreground text-xs text-warning font-medium`}
                  >
                    {`You qualified with ${
                      parseDecimalValuesOfNumber(
                        stackDetails?.qualifiedStack,
                        2,
                        checkToDisplayValueInK(stackDetails?.qualifiedStack),
                        checkToDisplayValueInL(stackDetails?.qualifiedStack),
                        checkToDisplayValueInCr(stackDetails?.qualifiedStack)
                      ) || 0
                    } Chips | HC`}
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default TourneyDetailsOverviewCard;
